import pathfinder from '@fiverr-private/pathfinder';
import {
    BQ_POPULAR_SERVICE_CLICK_ARCHITECTURE_AND_INTERIOR,
    BQ_POPULAR_SERVICE_CLICK_NO_CODE,
    BQ_POPULAR_SERVICE_CLICK_VIDEO_EDITING,
    BQ_POPULAR_SERVICE_CLICK_VIDEO_UGC,
    BQ_POPULAR_SERVICE_CLICK_WEBSITE_DEVELOPMENT,
} from '../../utils/biEvents/events/bigQueryEvents';

interface PopularService {
    label: string;
    href: string;
    eventName: string;
    isNew?: boolean;
}

const HEADER_LOHP_SOURCE = 'header_lohp';

export const DEFAULT_POPULAR_SERVICES: PopularService[] = [
    {
        label: 'website development',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'programming-tech', id: 'website-development' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_WEBSITE_DEVELOPMENT,
    },
    {
        label: 'architecture & interior design',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'graphics-design', id: 'architectural-design-services' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_ARCHITECTURE_AND_INTERIOR,
    },
    {
        label: 'UGC videos',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'video-animation', id: 'ugc-videos' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_VIDEO_UGC,
    },
    {
        label: 'video editing',
        href: pathfinder(
            'short_category_sub_category',
            { category_id: 'video-animation', id: 'video-editing' },
            { query: { source: HEADER_LOHP_SOURCE } }
        ),
        eventName: BQ_POPULAR_SERVICE_CLICK_VIDEO_EDITING,
    },
];

export const POPULAR_SERVICES_FOR_EN = [
    ...DEFAULT_POPULAR_SERVICES,
    {
        label: 'vibe coding',
        href: pathfinder('vibe_coding_page', {}, { query: { source: HEADER_LOHP_SOURCE } }),
        eventName: BQ_POPULAR_SERVICE_CLICK_NO_CODE,
        isNew: true,
    },
];
